import React, { useState, useEffect, useRef } from "react"
import Button from "./Button"
import { Button as AntBtn, Spin, Card, Col, Typography, Popconfirm, message, Tooltip } from "antd"
import { LoadingOutlined, UploadOutlined, CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons"
import { useStopwatch, formatTime } from "./customHooks"
import styled from "styled-components"
import "./styles.css"
import { Row } from "antd"
import { predictAudio } from "../Service/predict"
import Modal from "antd/lib/modal/Modal"

import anger from "../assets/emoji_anger.png"
import fear from "../assets/emoji_fear.png"
import happy from "../assets/emoji_happiness.png"
import neutral from "../assets/emoji_neutral.png"
import sad from "../assets/emoji_sadness.png"
const antIcon = <LoadingOutlined style={{ fontSize: 54 }} spin />
const { Text } = Typography
//const audioType = "audio/*";
const audioType = { type: "audio/wav" }

const StopWatch = () => {
    const [audios, setAudios] = useState([])
    const fileRef = useRef(null)
    const [chunks, setChunks] = useState([])
    const { isRunning, elapsedTime, startTimer, resetTimer } = useStopwatch()
    const [mediaRecorder, setMediaRecorder] = useState(null)
    const [stream, setStream] = useState(null)
    const [imageEmotion, setImageEmotion] = useState(neutral)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [result, setResult] = useState("")
    const [hasError, setHasError] = useState(false)
    const [fileError, setFileError] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)

    const triggerChange = () => {
        fileRef.current.click()
    }

    const changeHandler = (event) => {
        setFileError(false)
        const file = event.target.files[0]
        if (file) {
            const { name, type } = file
            if (type !== "audio/wav") {
                setFileError(true)
                message.error("Le fichier selectionné est invalide, veuillez choisir un autre")
            } else {
                message.success("Le fichier " + name + " a été importé avec succès")
                setSelectedFile(file)
                setAudios([URL.createObjectURL(file)])
            }
        }
    }

    const handleStartStop = () => {
        if (isRunning) {
            resetTimer()
            stopRecording()
        } else {
            startRecording()
            startTimer()
        }
    }

    const initMediaDevices = async () => {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        // show it to user
        //this.audio.src = window.URL.createObjectURL(stream);
        //this.audio.play();
        // init recording
        setMediaRecorder(new MediaRecorder(stream))
        // init data storage for video chunks
        setChunks([])
        // listen for data from media recorder
    }

    useEffect(() => {
        initMediaDevices()
    }, [])

    useEffect(() => {
        if (mediaRecorder) {
            let old = chunks
            mediaRecorder.ondataavailable = (e) => {
                if (e.data && e.data.size > 0) {
                    old.push(e.data)
                    setChunks(old)
                }
            }
        }
    }, [mediaRecorder, chunks])

    const startRecording = () => {
        // wipe old data chunks
        setChunks([])
        setAudios([])
        setFileError(false)
        setStream(null)
        setSelectedFile(null)
        // start recorder with 10ms buffer
        mediaRecorder && mediaRecorder.start(10)
        // say that we're recording
    }

    const stopRecording = () => {
        console.log("Stop recording")
        // stop the recorder
        mediaRecorder && mediaRecorder.stop()
        // say that we're not recording
        // save the video to memory
        saveAudio()
    }

    const saveAudio = () => {
        // convert saved chunks to blob
        const blob = new Blob(chunks, audioType)
        // generate video url from blob
        const audioURL = window.URL.createObjectURL(blob)
        // append videoURL to list of saved videos for rendering
        //const audiosList = audios.concat([audioURL]);
        setStream(blob)
        setAudios([audioURL])
    }

    const deleteAudio = (audioURL) => {
        // filter out current videoURL from the list of saved videos
        setSelectedFile(null)
        setHasError(false)
        setFileError(false)
        const audiosList = audios.filter((a) => a !== audioURL)
        setAudios(audiosList)
    }

    function confirmDelete(e) {
        message.success("Enregistrement supprimé avec succès")
        deleteAudio(audios[0])
    }

    const getEmotionImage = (emotion) => {
        if (emotion === "peur") {
            return fear
        } else if (emotion === "tristesse") {
            return sad
        } else if (emotion === "colere") {
            return anger
        } else if (emotion === "joie") {
            return happy
        } else {
            return neutral
        }
    }

    const predict = () => {
        setHasError(false)
        showModal()
        setResult("")
        setIsLoading(true)
        const audioToPredict = stream || selectedFile
        const typeOfData = stream ? "blob" : "file"
        predictAudio({ audio: audioToPredict, type: typeOfData })
            .then((response) => {
                const res = getMaxCount(response.data)
                setResult(res[0].label)
                setImageEmotion(getEmotionImage(res[0].label))
                setIsLoading(false)
            })
            .catch((e) => {
                setIsLoading(false)
                setHasError(true)
            })
    }

    const showModal = () => {
        setIsModalVisible(true)
    }

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const handleCancel = () => {
        setIsModalVisible(false)
    }

    function getMaxCount(arr) {
        var a = [],
            b = [],
            prev

        arr.sort()
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] !== prev) {
                a.push(arr[i])
                b.push(1)
            } else {
                b[b.length - 1]++
            }
            prev = arr[i]
        }

        let res = []
        a.map((data, i) => {
            let obj = {}
            obj["label"] = data
            obj["count"] = b[i]
            res.push(obj)
            return data
        })
        return res.sort((a, b) => b.count - a.count)
    }

    return (
        <Wrap>
            <Modal
                closable={false}
                maskClosable={false}
                title={isLoading ? "Prédiction en cours..." : "Prédiction terminé."}
                visible={isModalVisible}
                onOk={() => {
                    !isLoading && handleOk()
                }}
                onCancel={() => {
                    !isLoading && handleCancel()
                }}
            >
                {hasError ? (
                    <>
                        <Row justify="center">
                            <Text type="danger">
                                Oups ! une erreur est survenu, veuillez réessayer ou faire un autre enregistrement .
                            </Text>
                        </Row>
                    </>
                ) : (
                    <>
                        <Row style={{ justifyContent: "center", alignContent: "center" }}>
                            {isLoading ? (
                                <Spin indicator={antIcon} size={"large"} />
                            ) : (
                                <img alt="emotion" style={{ alignSelf: "center" }} src={imageEmotion} />
                            )}
                        </Row>
                        <Row justify="center">
                            {!isLoading && (
                                <Text style={{ alignSelf: "center" }}>
                                    Nous avons détécté l'émotion : <b>{result}</b>
                                </Text>
                            )}
                        </Row>
                    </>
                )}
            </Modal>
            <Row justify="center">
                <Col lg={11}>
                    <Card style={{ paddingBottom: 20 }}>
                        <p style={{ marginBottom: 20 }}>Deep Learning using CNN</p>
                        <Row
                            style={{
                                marginBottom: 10,
                                alignContent: "center",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <Tooltip
                                title={
                                    fileError
                                        ? "Fichier invalid"
                                        : selectedFile
                                        ? "Fichier chargé"
                                        : "Importer un fichier"
                                }
                            >
                                <input ref={fileRef} type="file" onChange={changeHandler} hidden />
                                <AntBtn
                                    type="primary"
                                    style={{
                                        background: fileError ? "#ff4d4f" : selectedFile ? "#52c41a" : "#1890ff",
                                        borderColor: fileError ? "#ff4d4f" : selectedFile ? "#52c41a" : "#1890ff"
                                    }}
                                    shape="circle"
                                    size="large"
                                    onClick={triggerChange}
                                    icon={
                                        fileError ? (
                                            <InfoCircleOutlined />
                                        ) : selectedFile ? (
                                            <CheckCircleOutlined />
                                        ) : (
                                            <UploadOutlined />
                                        )
                                    }
                                ></AntBtn>
                            </Tooltip>
                            <Col style={{ marginInline: 20 }}>
                                <Text style={{ fontSize: 20 }}>{formatTime(elapsedTime)}</Text>
                            </Col>
                            <Col>
                                <Tooltip
                                    title={
                                        isRunning
                                            ? "Arrêter l'enregistrement vocal"
                                            : "Commencer l'enregistrement vocal"
                                    }
                                >
                                    <Button
                                        shape="circle"
                                        onClick={handleStartStop}
                                        status={isRunning ? "running" : "stop"}
                                    ></Button>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Text type={fileError && "danger"}>
                            {isRunning
                                ? "Enregistrement vocal en cours ..."
                                : fileError
                                ? "Veuillez selectionner un fichier audio .wav"
                                : "Toucher pour commencer l'enregistrement vocal / importer un fichier"}
                        </Text>
                        <Col
                            lg={24}
                            xs={24}
                            sm={24}
                            xl={24}
                            style={{
                                marginTop: 20,
                                borderWidth: 1,
                                alignSelf: "center",
                                justifyContent: "center",
                                alignContent: "center"
                            }}
                        >
                            {audios.map((audioURL, i) => (
                                <div key={`audio_${i}`}>
                                    <Row
                                        style={{
                                            justifyContent: "center",
                                            alignContent: "center",
                                            alignItems: "center"
                                        }}
                                    >
                                        <audio controls src={audioURL} />
                                        <div>
                                            <Popconfirm
                                                title="Etes vous sûr de vouloir supprimer cet enregistrement ?"
                                                onConfirm={confirmDelete}
                                                onCancel={() => {}}
                                                okText="Oui"
                                                cancelText="Non"
                                            >
                                                <AntBtn
                                                    type={"primary"}
                                                    size="large"
                                                    style={{
                                                        marginInlineStart: 5,
                                                        background: "#ff4d4f",
                                                        borderColor: "#ff4d4f"
                                                    }}
                                                    //onClick={() => deleteAudio(audioURL)}
                                                >
                                                    Supprimer
                                                </AntBtn>
                                            </Popconfirm>
                                            <AntBtn
                                                type={"primary"}
                                                size="large"
                                                style={{
                                                    marginInlineStart: 5,
                                                    background: "#002766",
                                                    borderColor: "#002766"
                                                }}
                                                onClick={predict}
                                            >
                                                Evaluer
                                            </AntBtn>
                                            {/*<AntBtn
                  type={"primary"}
                  size="large"
                  style={{
                    marginInlineStart: 5,
                  }}
                  onClick={() => {}}
                >
                  Envoyer
                </AntBtn>
                <Select
                  size="large"
                  style={{
                    alignSelf: "center",
                    marginInlineStart: 5,
                  }}
                  defaultValue={"colere"}
                >
                  <Option value="colere">Colère</Option>
                  <Option value="tristesse">Tristesse</Option>
                  <Option value="joie">Joie</Option>
                  <Option value="Neutre">Neutre</Option>
                </Select>*/}
                                        </div>
                                    </Row>
                                </div>
                            ))}
                        </Col>
                    </Card>
                </Col>
            </Row>
        </Wrap>
    )
}

const Wrap = styled.div`
    flex: 1;
    color: #fff;
    padding-top: 5rem;
    width: 100%;
    text-align: center;
    font-family: sans-serif;
    font-size: 18px;
    justify-content: center;
`

const StopWatchWrap = styled.div`
    display: flex;
    width: 100%;
`

export const BigStopWatch = () => (
    <StopWatchWrap>
        <StopWatch />
    </StopWatchWrap>
)
